import React, { useState, useContext, useRef, useEffect } from "react"
import { Content } from "./style"
import freight_act from '../../../assets/router/routersTabHeader/freight-active.svg';
import local_act from '../../../assets/sidemenu/local-active.svg';
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from "../../../components/styles/subheader-style"
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom"
import { TypeMainOutlet } from ".."
import RouterButtons from "./routerButtons";
import RouterFiltersMenu from '../../../components/router/FiltersMenu/RoutesFiltersMenu'; 
import FreightFiltersMenu from '../../../components/router/FiltersMenu/FreightFiltersMenu';
import FiltersHeader from '../../../components/Stock/FiltersHeader'; 
import TableFiltersContext from "../../../contexts/TableFiltersContext"; 
import filter from '../../../assets/stock/TableMovementHeader/filter.svg' 

export interface RouterOutletType {
    tabIndex: number
    setTabIndex: React.Dispatch<React.SetStateAction<number>>
    search: string;
}

interface RouterBody{
    id: number;
    date: string;
    status: string;
    freightIds: number[];
    track: string | undefined;
    url: string;
    origin: string;
    vehicleId: number;
}

const tabs = [
    {path: '', image: freight_act, name: 'Fretes'},
    {path: 'routers', image: local_act, name: 'Roteiros'},
    // {path: 'vehicles', image: vehicles_act, name: 'Veículos'},
    // {path: 'dateAndTime', image: dateAndTime_act, name: 'Datas e horários'},
    // {path: 'teste', image: dateAndTime_act, name: 'teste'}

]

const RouterSubHeader:React.FC<{tabIndexActived:number}> = ({tabIndexActived})=>{
    const navigate = useNavigate() 
    const location = useLocation();

    const [isRouterFiltersMenuOpen, setIsRouterFiltersMenuOpen] = useState<boolean>(false);
    const routerFilterMenuRef = useRef<HTMLDivElement>(null); 
    const routerFilterDropdownRef = useRef<HTMLDivElement>(null);

    const [isFreightFiltersMenuOpen, setIsFreightFiltersMenuOpen] = useState<boolean>(false);
    const freightFilterMenuRef = useRef<HTMLDivElement>(null); 
    const freightFilterDropdownRef = useRef<HTMLDivElement>(null); 

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                routerFilterMenuRef.current &&
                routerFilterDropdownRef.current &&
                !routerFilterMenuRef.current.contains(event.target as Node) &&
                !routerFilterDropdownRef.current.contains(event.target as Node)
            ) {
                setIsRouterFiltersMenuOpen(false);
            }
            if (
                freightFilterMenuRef.current &&
                freightFilterDropdownRef.current &&
                !freightFilterMenuRef.current.contains(event.target as Node) &&
                !freightFilterDropdownRef.current.contains(event.target as Node)
            ) {
                setIsFreightFiltersMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const isFreightTabActive = tabIndexActived === 0;
    const isRouterTabActive = tabIndexActived === 1;

    return(
        <SubHeaderContainer>
            <LeftSide>
                <SectionName>Roterização</SectionName>
            {(location.pathname !== '/panel/router/routers/create' && location.pathname !== '/panel/router/routers/edit') &&
                <TabsDiv>
                {tabs.map((tab, index) => (
                <Tab
                    key={index}
                    $isFirst={index === 0}
                    $isLast={index === tabs.length - 1}
                    $isActive={index === tabIndexActived}
                    onClick={() => {
                        if(index !== tabIndexActived) navigate(tab.path)
                    }}
                >
                    <img src={tab.image} alt={`${tab.path}-icon`} />
                    {tab.name}
                </Tab>
                ))}
            </TabsDiv>}
            </LeftSide>
            <RightSide>
                {(location.pathname !== '/panel/router/routers/create' && location.pathname !== '/panel/router/routers/edit') &&
                <>
                    {isFreightTabActive && (
                        <>
                            <OptionsButton
                                onClick={() => setIsFreightFiltersMenuOpen(prev => !prev)}
                                ref={freightFilterMenuRef}
                            >
                                <img src={filter} alt="filter-icon" />
                            </OptionsButton>
                            {isFreightFiltersMenuOpen ? <FreightFiltersMenu ref={freightFilterDropdownRef} /> : null}
                        </>
                    )}

                    {isRouterTabActive && (
                        <>
                            <OptionsButton
                                onClick={() => setIsRouterFiltersMenuOpen(prev => !prev)}
                                ref={routerFilterMenuRef}
                            >
                                <img src={filter} alt="filter-icon" />
                            </OptionsButton>
                            {isRouterFiltersMenuOpen ? <RouterFiltersMenu ref={routerFilterDropdownRef} /> : null}
                        </>
                    )}
                    
                    <RouterButtons index={tabIndexActived}/>
                </>
                }
            </RightSide>
        </SubHeaderContainer>
    )
} 
const RouterContent = ()=>{
    const [ tabIndex, setTabIndex ] = useState<number>(0)
    const { search } = useOutletContext<TypeMainOutlet>()
    const { routerStatusFilter, freightStatusFilter } = useContext(TableFiltersContext); 
    const [bodyRouter, setBodyRouter] = useState<RouterBody>(
        {
            id:0,
            date : '',
            status: "A programar",
            freightIds: [],
            track: '',
            url: 'https://www.google.com.br/maps?q=06278-010,%20Brasil&output=embed',
            origin: 'vendas',
            vehicleId: 0
        }
    )
    
    const hasFilters = routerStatusFilter.length > 0 || freightStatusFilter.length > 0;
    
    return (
        <>
            <RouterSubHeader tabIndexActived={tabIndex}/>
            
            {hasFilters ? <FiltersHeader /> : null} 

            <Content $hasFilters={hasFilters}>
                <Outlet
                    context={{
                        tabIndex,
                        setTabIndex,
                        search
                    }}
                />
            </Content>
        </>
    )
}
export default RouterContent